export default __webpack_public_path__ + "static/media/bg-hero.f0ba9ab3.jpg";